import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const TaskItem = ({ task, onViewClick, selectedTask, setSelectedTask }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        height: 50,
        backgroundColor: hover ? colors.greenLight : colors.white,
        display: "flex",
        alignItems: "center",
        fontWeight: "bold",
        fontSize: 10,
        color: hover ? colors.white : "#000000",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.05,
        }}
      ></div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.1,
        }}
      >
        {task.taskType}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.2,
        }}
      >
        {task.taskTitle}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.15,
        }}
      >
        {task.agencyName}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.25,
        }}
      >
        {task.requestedByUserId}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.1,
        }}
      >
        {task.taskStatus}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",

          alignItems: "center",
          flex: 0.15,

          // borderStyle: "solid",
        }}
      >
        <BaseButtons
          label={"MANAGE"}
          borderRadius={4}
          backgroundColor={colors.greenDark}
          width={100}
          height={30}
          onClick={onViewClick}
        />
      </div>
    </div>
  );
};

export default TaskItem;
